export default __webpack_public_path__ + "static/media/male-player.c4489083.jpg";